module.exports = __webpack_public_path__ + "img/status-change.9ab6fddf.png";